import axios from 'axios';
import ErrorService from './error.service';

const Http = {};
Http.http = null;
Http.requestCount = 0;
Http.loadingBar = () => {
};

// Not promises
Http.set = (user) => {
  if (!user) return;
  Http.http = axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {
      'x-access-token': user.authToken
    }
  });

  Http.http.interceptors.request.use((config) => {
    Http.requestCount++;
    Http.loadingBar(!!Http.requestCount);
    return config;
  }, (error) => Promise.reject(error));

  Http.http.interceptors.response.use((response) => {
    Http.requestCount--;
    Http.loadingBar(!!Http.requestCount);
    return response;
  }, (error) => {
    Http.requestCount--;
    Http.loadingBar(!!Http.requestCount);
    ErrorService.handle(error);
    return Promise.reject(error);
  });
};


Http.setLoadingBar = (loading) => {
  Http.loadingBar = loading;
};

Http.get = () => Http.http;
// End not promises
export default Http;
